import OurVue from "vue";
import breakpoint from "./services/app/breakpoint";
import goto from "./services/app/goto";
import metrics from "./services/metrics";

import Resize from "./directives/resize";
import Intersect from "./directives/intersect";

import countryNameFilter from "./filters/country";

export default function install(Vue, opts = {}) {
  if (OurVue !== Vue) {
    console.error("Multiple instances of Vue detected");
  }

  Vue.filter("country", countryNameFilter);

  const directives = Object.assign(
    {
      Resize,
      Intersect
    },
    opts.directives || {}
  );

  Vue.prototype.$app = new Vue({
    mixins: [
      breakpoint, // Калькуляция текущей секции media query. Доступно через this.$app.breakpoint
      metrics,
      goto
    ]
    // data: {},
    // methods: {},
  });

  if (directives) {
    for (const name in directives) {
      Vue.directive(name, directives[name]);
    }
  }

  (function registerComponents(components) {
    if (components) {
      for (const key in components) {
        const component = components[key];
        if (component && !registerComponents(component.$_subcomponents)) {
          Vue.component(key, component);
        }
      }
      return true;
    }
    return false;
  })(opts.components);
}
